import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class EnrolmentTaskApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/enrolment-tasks`;
    }

    getTasksByEnrolmentId(enrolmentId: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/enrolment/${enrolmentId}`);
    }

    createEnrolmentTask(task: any): Observable<any> {
        return this.httpClient.post<any>(this.url, task);
    }

    updateEnrolmentTask(task: any): Observable<any> {
        return this.httpClient.put<any>(this.url, task);
    }

    deleteEnrolmentTask(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }
}

